//配置全局访问接口地址
let commonUrl = "https://dz28.ys202.com/";

let baseUrl = {
    commonUrl
}

export default baseUrl
